import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import styles from '../../controllers/Dialog.module.sass'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { booleanOptions } from 'controllers/TaskManager/formOptions'
import HFOptionGroup from 'components/HFInputs/HFOptionGroup'

export const ForwardingMedicalAssistanceController = (props) => {
	const { i18n } = useGlobal()
	const { accidentType } = props

	return (
		<fieldset>
			<VStack className={styles['option-group-list']}>
				<VStack className={styles['form-input']}>
					<h5>{i18n`Injured had medical assistance?`}</h5>
					<HFOptionGroup
						className={`${styles['option-group']} ${styles['--horizontal-flex']}`}
						name='clinicalAssistance.injuredHasClinicalAssistance'
						type='boolean'
						options={booleanOptions}
					/>
				</VStack>

				{accidentType === 'AD' ? (
					<>
						<VStack className={styles['form-input']}>
							<h5>{i18n`Had the need of stop doing sports?`}</h5>
							<HFOptionGroup
								className={`${styles['option-group']} ${styles['--horizontal-flex']}`}
								name='clinicalAssistance.hasStoppedWorking'
								type='boolean'
								options={booleanOptions}
							/>
						</VStack>
					</>
				) : null}

				{accidentType !== 'AD' ? (
					<>
						<VStack className={styles['form-input']}>
							<h5>{i18n`Had the need of stop working?`}</h5>
							<HFOptionGroup
								className={`${styles['option-group']} ${styles['--horizontal-flex']}`}
								name='clinicalAssistance.hasStoppedWorking'
								type='boolean'
								options={booleanOptions}
							/>
						</VStack>
					</>
				) : null}

				<VStack className={styles['form-input']}>
					<h5>{i18n`Needs central provider`}</h5>
					<HFOptionGroup
						className={`${styles['option-group']} ${styles['--horizontal-flex']}`}
						name='accident.isSerious'
						type='boolean'
						options={booleanOptions}
						shouldUnregister={false}
					/>
				</VStack>
			</VStack>
		</fieldset>
	)
}
